import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className={`button--publish ${props?.toggle ? 'button--publish--on' : ''}`} icon='publish'>{ children ? children : 'Publish' }</Button>
}